"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSharedInfo = exports.setSharedInfo = exports.originReference = void 0;
const getSharedInfo_1 = require("./getSharedInfo");
const setSharedInfo_1 = require("./setSharedInfo");
if (!window.sharedInfo) {
    window.sharedInfo = {};
}
exports.originReference = window.sharedInfo;
exports.setSharedInfo = setSharedInfo_1.SetSharedInfo.getInstance();
exports.getSharedInfo = getSharedInfo_1.GetSharedInfo.getInstance();
//# sourceMappingURL=utils.js.map